module.exports = __webpack_public_path__ + "why13.webp?c427aedd93d8a316b06c26cba4b8f3c7";